export default __webpack_public_path__ + "c934ea74c1af90332c697bc0749fb69b.pdf";